import ReferralsContainer from "../../referralsContainer";
export default ReferralsContainer;
